import { render, staticRenderFns } from "./SuggestionCard.vue?vue&type=template&id=53b5693d&scoped=true&"
import script from "./SuggestionCard.vue?vue&type=script&lang=js&"
export * from "./SuggestionCard.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionCard.vue?vue&type=style&index=0&id=53b5693d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b5693d",
  null
  
)

export default component.exports